import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { NivelRango } from '../../_models/nivel-rango';
import { Nivel } from '../../_models/nivel';
import { NivelesService } from '../../_services/niveles.service';
import { NivelRangoService } from '../../_services/nivel-rango.service';

@Component( {
  selector: 'app-niveles-detalle',
  templateUrl: 'niveles-detalle.component.html'
} )

export class NivelesDetalleComponent implements OnInit {

  nivel: Nivel;
  nivelesRangos: NivelRango[] = [];
  carInformacionInicial = true;
  columnasR:any[] = [];

  constructor( private route: ActivatedRoute,
               private nivelesServicio: NivelesService,
               private nivelRangoService: NivelRangoService,
               private nav: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.columnasR = [
      { field: 'nombreRango', header: this.nav.buscarMensaje( 'NIVELES.LBL_NOMBRERANGO' ), sort: true },
      { field: 'rangoMaximo', header: this.nav.buscarMensaje( 'NIVELES.LBL_RANGOMAXIMOT' ), sort: true },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'NIVELES.LBL_HABILITADO' ), sort: true },
    ];


    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.nivelesServicio.obtener( params[ 'id' ] ),
        this.nivelRangoService.listadoNivelRangoByNivel( params[ 'id' ] ),
      ).subscribe( ( [ nivel, nivelesRangos ] ) => {
        this.nivel = nivel;
        this.nivelesRangos = nivelesRangos;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
